import { useEffect, useCallback } from 'react';
import { loggerService } from 'js/services/logger.service';

export const useEnableLogger = () => {
    const enableLogger = useCallback(() => {
        loggerService.enableLogger();
    }, []);

    useEffect(() => {
        document.addEventListener('enableLogger', enableLogger);

        return () => document.removeEventListener('enableLogger', enableLogger);
    }, [enableLogger]);
};
